import { SortByOptions } from 'src/app/components/search/search.enum';
import { SortingOrderType } from 'src/app/interfaces/search.interface';

export enum SortCategories {
  NAME_ASC = 'name_asc',
  NAME_DESC = 'name_desc',
  DATE_ASC = 'date_asc',
  DATE_DESC = 'date_desc',
  SCORE_DESC = 'score_desc',
}

export interface SortOptions {
  sortTitle: string;
  sortCategory: SortCategories;
}

export const DEFAULT_SORT_OPTIONS: SortOptions[] = [
  {
    sortTitle: SortByOptions.NAME_A_Z,
    sortCategory: SortCategories.NAME_ASC,
  },
  {
    sortTitle: SortByOptions.NAME_Z_A,
    sortCategory: SortCategories.NAME_DESC,
  },
  {
    sortTitle: SortByOptions.NEWEST,
    sortCategory: SortCategories.DATE_DESC,
  },
  {
    sortTitle: SortByOptions.OLDEST,
    sortCategory: SortCategories.DATE_ASC,
  },
  {
    sortTitle: SortByOptions.SCORE,
    sortCategory: SortCategories.SCORE_DESC,
  },
];

export const NAME_SORT_OPTIONS: SortOptions[] = [
  {
    sortTitle: 'SORT_BY_A_Z',
    sortCategory: SortCategories.NAME_ASC,
  },
  {
    sortTitle: 'SORT_BY_Z_A',
    sortCategory: SortCategories.NAME_DESC,
  },
];

export function isAscendingIcon(sortCategories: SortCategories): boolean {
  switch (sortCategories) {
    case SortCategories.DATE_ASC:
    case SortCategories.NAME_ASC:
      return true; // should flip in next implementation of sort-icon-item
    case SortCategories.DATE_DESC:
    case SortCategories.NAME_DESC:
    case SortCategories.SCORE_DESC:
      return false;
  }
}

export function getSortingOrderType(sortCategories: SortCategories): SortingOrderType {
  switch (sortCategories) {
    case SortCategories.NAME_ASC:
    case SortCategories.NAME_DESC:
      return SortingOrderType.NAME;
    case SortCategories.DATE_ASC:
    case SortCategories.DATE_DESC:
      return SortingOrderType.DATE;
    case SortCategories.SCORE_DESC:
      return SortingOrderType.SCORE;
  }
}
